export default [
    {
        date: 1584298270032,
        row: 18,
        col: 17,
        squares: [
            [3, 1, "#000000"],
            [1, 1, "#000000"],
            [2, 2, "#000000"],
            [1, 3, "#000000"],
            [3, 3, "#000000"],
            [2, 4, "#000000"],
            [1, 5, "#000000"],
            [3, 5, "#000000"],
            [2, 6, "#000000"],
            [1, 7, "#000000"],
            [3, 7, "#000000"],
            [2, 8, "#000000"],
            [1, 9, "#000000"],
            [3, 9, "#000000"],
            [2, 10, "#000000"],
            [1, 11, "#000000"],
            [3, 11, "#000000"],
            [2, 12, "#000000"],
            [1, 13, "#000000"],
            [3, 13, "#000000"],
            [2, 14, "#000000"],
            [1, 15, "#000000"],
            [3, 15, "#000000"],
            [2, 16, "#000000"],
            [1, 17, "#000000"],
            [3, 17, "#000000"],
            [4, 1, "#9900FF"],
            [6, 1, "#9900FF"],
            [5, 2, "#9900FF"],
            [4, 3, "#9900FF"],
            [6, 3, "#9900FF"],
            [5, 4, "#9900FF"],
            [4, 5, "#9900FF"],
            [6, 5, "#9900FF"],
            [5, 6, "#9900FF"],
            [4, 7, "#9900FF"],
            [6, 7, "#9900FF"],
            [5, 8, "#9900FF"],
            [4, 9, "#9900FF"],
            [6, 9, "#9900FF"],
            [5, 10, "#9900FF"],
            [4, 11, "#9900FF"],
            [6, 11, "#9900FF"],
            [5, 12, "#9900FF"],
            [4, 13, "#9900FF"],
            [6, 13, "#9900FF"],
            [5, 14, "#9900FF"],
            [4, 15, "#9900FF"],
            [6, 15, "#9900FF"],
            [5, 16, "#9900FF"],
            [4, 17, "#9900FF"],
            [6, 17, "#9900FF"],
            [5, 17, "#FF00FF"],
            [4, 16, "#FF00FF"],
            [6, 16, "#FF00FF"],
            [5, 15, "#FF00FF"],
            [4, 14, "#FF00FF"],
            [6, 14, "#FF00FF"],
            [5, 13, "#FF00FF"],
            [4, 12, "#FF00FF"],
            [5, 11, "#FF00FF"],
            [6, 12, "#FF00FF"],
            [6, 10, "#FF00FF"],
            [4, 10, "#FF00FF"],
            [5, 9, "#FF00FF"],
            [4, 8, "#FF00FF"],
            [5, 7, "#FF00FF"],
            [6, 8, "#FF00FF"],
            [4, 6, "#FF00FF"],
            [5, 5, "#FF00FF"],
            [6, 6, "#FF00FF"],
            [6, 4, "#FF00FF"],
            [4, 4, "#FF00FF"],
            [4, 2, "#FF00FF"],
            [5, 3, "#FF00FF"],
            [5, 1, "#FF00FF"],
            [6, 2, "#FF00FF"],
            [2, 5, "#D9D9D9"],
            [1, 4, "#D9D9D9"],
            [1, 6, "#D9D9D9"],
            [1, 8, "#D9D9D9"],
            [2, 7, "#D9D9D9"],
            [3, 6, "#D9D9D9"],
            [3, 4, "#D9D9D9"],
            [2, 3, "#D9D9D9"],
            [3, 2, "#D9D9D9"],
            [2, 1, "#D9D9D9"],
            [1, 2, "#D9D9D9"],
            [2, 9, "#D9D9D9"],
            [3, 8, "#D9D9D9"],
            [3, 10, "#D9D9D9"],
            [1, 10, "#D9D9D9"],
            [2, 11, "#D9D9D9"],
            [1, 12, "#D9D9D9"],
            [3, 12, "#D9D9D9"],
            [2, 13, "#D9D9D9"],
            [3, 14, "#D9D9D9"],
            [1, 14, "#D9D9D9"],
            [2, 15, "#D9D9D9"],
            [1, 16, "#D9D9D9"],
            [2, 17, "#D9D9D9"],
            [3, 16, "#D9D9D9"],
            [7, 1, "#FFFF00"],
            [9, 1, "#FFFF00"],
            [8, 2, "#FFFF00"],
            [7, 3, "#FFFF00"],
            [9, 3, "#FFFF00"],
            [8, 4, "#FFFF00"],
            [7, 5, "#FFFF00"],
            [9, 5, "#FFFF00"],
            [8, 6, "#FFFF00"],
            [7, 7, "#FFFF00"],
            [9, 7, "#FFFF00"],
            [8, 8, "#FFFF00"],
            [7, 9, "#FFFF00"],
            [9, 9, "#FFFF00"],
            [8, 10, "#FFFF00"],
            [7, 11, "#FFFF00"],
            [9, 11, "#FFFF00"],
            [8, 12, "#FFFF00"],
            [7, 13, "#FFFF00"],
            [9, 13, "#FFFF00"],
            [8, 14, "#FFFF00"],
            [7, 15, "#FFFF00"],
            [9, 15, "#FFFF00"],
            [8, 16, "#FFFF00"],
            [7, 17, "#FFFF00"],
            [9, 17, "#FFFF00"],
            [8, 1, "#FF0000"],
            [7, 2, "#FF0000"],
            [9, 2, "#FF0000"],
            [8, 3, "#FF0000"],
            [7, 4, "#FF0000"],
            [8, 5, "#FF0000"],
            [9, 4, "#FF0000"],
            [7, 6, "#FF0000"],
            [9, 6, "#FF0000"],
            [8, 7, "#FF0000"],
            [7, 8, "#FF0000"],
            [9, 8, "#FF0000"],
            [8, 9, "#FF0000"],
            [7, 10, "#FF0000"],
            [8, 11, "#FF0000"],
            [9, 10, "#FF0000"],
            [7, 12, "#FF0000"],
            [9, 12, "#FF0000"],
            [8, 13, "#FF0000"],
            [7, 14, "#FF0000"],
            [9, 14, "#FF0000"],
            [8, 15, "#FF0000"],
            [7, 16, "#FF0000"],
            [8, 17, "#FF0000"],
            [9, 16, "#FF0000"],
            [12, 1, "#00FF00"],
            [10, 1, "#00FF00"],
            [10, 3, "#00FF00"],
            [12, 3, "#00FF00"],
            [11, 2, "#00FF00"],
            [11, 4, "#00FF00"],
            [11, 6, "#00FF00"],
            [11, 8, "#00FF00"],
            [11, 10, "#00FF00"],
            [11, 12, "#00FF00"],
            [11, 14, "#00FF00"],
            [11, 16, "#00FF00"],
            [10, 5, "#00FF00"],
            [10, 7, "#00FF00"],
            [10, 9, "#00FF00"],
            [10, 11, "#00FF00"],
            [10, 13, "#00FF00"],
            [10, 15, "#00FF00"],
            [10, 17, "#00FF00"],
            [12, 17, "#00FF00"],
            [12, 15, "#00FF00"],
            [12, 13, "#00FF00"],
            [12, 11, "#00FF00"],
            [12, 9, "#00FF00"],
            [12, 7, "#00FF00"],
            [11, 5, "#00FFFF"],
            [12, 5, "#00FF00"],
            [10, 4, "#00FFFF"],
            [11, 3, "#00FFFF"],
            [12, 4, "#00FFFF"],
            [12, 2, "#00FFFF"],
            [11, 1, "#00FFFF"],
            [10, 2, "#00FFFF"],
            [10, 6, "#00FFFF"],
            [12, 6, "#00FFFF"],
            [11, 7, "#00FFFF"],
            [10, 8, "#00FFFF"],
            [12, 8, "#00FFFF"],
            [11, 9, "#00FFFF"],
            [10, 10, "#00FFFF"],
            [11, 11, "#00FFFF"],
            [12, 10, "#00FFFF"],
            [10, 12, "#00FFFF"],
            [11, 13, "#00FFFF"],
            [12, 12, "#00FFFF"],
            [10, 14, "#00FFFF"],
            [11, 15, "#00FFFF"],
            [12, 14, "#00FFFF"],
            [12, 16, "#00FFFF"],
            [11, 17, "#00FFFF"],
            [10, 16, "#00FFFF"],
            [13, 17, "#0000FF"],
            [15, 17, "#0000FF"],
            [14, 16, "#0000FF"],
            [14, 15, "#4A86E8"],
            [13, 15, "#0000FF"],
            [15, 15, "#0000FF"],
            [14, 14, "#0000FF"],
            [13, 16, "#4A86E8"],
            [15, 16, "#4A86E8"],
            [14, 17, "#4A86E8"],
            [15, 14, "#4A86E8"],
            [13, 14, "#4A86E8"],
            [13, 13, "#0000FF"],
            [15, 13, "#0000FF"],
            [13, 11, "#0000FF"],
            [14, 12, "#0000FF"],
            [15, 11, "#0000FF"],
            [14, 10, "#0000FF"],
            [14, 8, "#0000FF"],
            [14, 6, "#0000FF"],
            [13, 4, "#4A86E8"],
            [14, 4, "#0000FF"],
            [14, 2, "#0000FF"],
            [13, 1, "#0000FF"],
            [13, 3, "#0000FF"],
            [15, 3, "#0000FF"],
            [15, 1, "#0000FF"],
            [15, 5, "#0000FF"],
            [15, 7, "#0000FF"],
            [13, 5, "#0000FF"],
            [13, 7, "#0000FF"],
            [15, 9, "#0000FF"],
            [13, 9, "#0000FF"],
            [14, 13, "#4A86E8"],
            [15, 12, "#4A86E8"],
            [13, 12, "#4A86E8"],
            [14, 11, "#4A86E8"],
            [13, 10, "#4A86E8"],
            [15, 10, "#4A86E8"],
            [14, 9, "#4A86E8"],
            [13, 8, "#4A86E8"],
            [15, 8, "#4A86E8"],
            [14, 7, "#4A86E8"],
            [13, 6, "#4A86E8"],
            [15, 6, "#4A86E8"],
            [14, 5, "#4A86E8"],
            [14, 3, "#4A86E8"],
            [13, 2, "#4A86E8"],
            [14, 1, "#4A86E8"],
            [15, 2, "#4A86E8"],
            [15, 4, "#4A86E8"],
            [18, 17, "#980000"],
            [16, 17, "#980000"],
            [17, 16, "#980000"],
            [16, 15, "#980000"],
            [18, 15, "#980000"],
            [17, 14, "#980000"],
            [16, 13, "#980000"],
            [18, 13, "#980000"],
            [17, 12, "#980000"],
            [16, 11, "#980000"],
            [18, 11, "#980000"],
            [17, 10, "#980000"],
            [16, 9, "#980000"],
            [18, 9, "#980000"],
            [17, 8, "#980000"],
            [16, 7, "#980000"],
            [18, 7, "#980000"],
            [17, 6, "#980000"],
            [16, 5, "#980000"],
            [18, 5, "#980000"],
            [17, 4, "#980000"],
            [16, 3, "#980000"],
            [17, 2, "#980000"],
            [16, 1, "#980000"],
            [18, 1, "#980000"],
            [18, 3, "#980000"],
            [16, 12, "#5CB85C"],
            [17, 13, "#5CB85C"],
            [17, 11, "#5CB85C"],
            [16, 10, "#5CB85C"],
            [17, 9, "#5CB85C"],
            [18, 12, "#5CB85C"],
            [18, 14, "#5CB85C"],
            [18, 10, "#5CB85C"],
            [16, 14, "#5CB85C"],
            [17, 15, "#5CB85C"],
            [16, 16, "#5CB85C"],
            [17, 17, "#5CB85C"],
            [18, 16, "#5CB85C"],
            [16, 8, "#5CB85C"],
            [18, 8, "#5CB85C"],
            [17, 7, "#5CB85C"],
            [16, 6, "#5CB85C"],
            [17, 5, "#5CB85C"],
            [18, 6, "#5CB85C"],
            [18, 4, "#5CB85C"],
            [16, 4, "#5CB85C"],
            [17, 3, "#5CB85C"],
            [16, 2, "#5CB85C"],
            [17, 1, "#5CB85C"],
            [18, 2, "#5CB85C"],
        ],
    },
    {
        date: 1495622918473,
        row: 18,
        col: 17,
        squares: [
            [18, 4, "#000000"],
            [17, 4, "#000000"],
            [17, 5, "#000000"],
            [18, 5, "#000000"],
            [18, 14, "#000000"],
            [17, 14, "#000000"],
            [17, 13, "#000000"],
            [18, 13, "#000000"],
            [17, 3, "#FF0000"],
            [17, 2, "#FF0000"],
            [16, 3, "#FF0000"],
            [16, 4, "#FF0000"],
            [16, 5, "#FF0000"],
            [16, 6, "#FF0000"],
            [17, 6, "#FF0000"],
            [16, 7, "#FF0000"],
            [17, 7, "#FF0000"],
            [16, 8, "#FF0000"],
            [17, 8, "#FF0000"],
            [16, 9, "#FF0000"],
            [17, 9, "#FF0000"],
            [16, 10, "#FF0000"],
            [17, 10, "#FF0000"],
            [16, 11, "#FF0000"],
            [17, 11, "#FF0000"],
            [16, 12, "#FF0000"],
            [17, 12, "#FF0000"],
            [16, 13, "#FF0000"],
            [16, 14, "#FF0000"],
            [17, 15, "#FF0000"],
            [16, 15, "#FF0000"],
            [15, 14, "#FF0000"],
            [15, 15, "#FF0000"],
            [15, 13, "#FF0000"],
            [14, 13, "#0000FF"],
            [13, 13, "#0000FF"],
            [12, 12, "#000000"],
            [12, 11, "#000000"],
            [12, 10, "#000000"],
            [12, 9, "#000000"],
            [12, 8, "#000000"],
            [12, 7, "#000000"],
            [12, 6, "#000000"],
            [13, 5, "#000000"],
            [14, 4, "#000000"],
            [15, 4, "#FF0000"],
            [15, 3, "#FF0000"],
            [15, 5, "#FF0000"],
            [14, 5, "#FF0000"],
            [15, 6, "#FF0000"],
            [15, 9, "#FF0000"],
            [14, 9, "#FF0000"],
            [13, 9, "#FF0000"],
            [14, 10, "#00FF00"],
            [15, 10, "#00FF00"],
            [15, 11, "#00FF00"],
            [14, 7, "#00FF00"],
            [15, 7, "#00FF00"],
            [15, 8, "#00FF00"],
            [6, 1, "#0000FF"],
            [5, 3, "#0000FF"],
            [5, 2, "#0000FF"],
            [3, 4, "#0000FF"],
            [4, 4, "#0000FF"],
            [3, 5, "#0000FF"],
            [3, 6, "#0000FF"],
            [3, 7, "#0000FF"],
            [3, 8, "#0000FF"],
            [3, 9, "#0000FF"],
            [3, 10, "#0000FF"],
            [3, 11, "#0000FF"],
            [3, 12, "#0000FF"],
            [3, 13, "#0000FF"],
            [3, 14, "#FFFF00"],
            [3, 15, "#FFFF00"],
            [2, 17, "#FFFF00"],
            [2, 16, "#FFFF00"],
            [2, 15, "#FFFF00"],
            [2, 14, "#0000FF"],
            [2, 13, "#0000FF"],
            [2, 12, "#0000FF"],
            [2, 10, "#0000FF"],
            [2, 9, "#0000FF"],
            [2, 8, "#0000FF"],
            [2, 7, "#0000FF"],
            [2, 11, "#0000FF"],
            [2, 5, "#0000FF"],
            [2, 6, "#0000FF"],
            [2, 4, "#0000FF"],
            [3, 3, "#0000FF"],
            [4, 3, "#0000FF"],
            [4, 2, "#0000FF"],
            [3, 2, "#0000FF"],
            [2, 2, "#0000FF"],
            [2, 3, "#0000FF"],
            [2, 1, "#0000FF"],
            [3, 1, "#0000FF"],
            [4, 1, "#0000FF"],
            [5, 1, "#0000FF"],
            [1, 1, "#0000FF"],
            [1, 2, "#0000FF"],
            [1, 3, "#0000FF"],
            [1, 4, "#0000FF"],
            [1, 5, "#0000FF"],
            [1, 8, "#0000FF"],
            [1, 7, "#0000FF"],
            [1, 6, "#0000FF"],
            [1, 9, "#0000FF"],
            [1, 10, "#0000FF"],
            [1, 11, "#0000FF"],
            [1, 13, "#0000FF"],
            [1, 15, "#FFFF00"],
            [1, 16, "#FFFF00"],
            [1, 17, "#FFFF00"],
            [1, 14, "#0000FF"],
            [1, 12, "#0000FF"],
            [18, 1, "#666666"],
            [18, 2, "#666666"],
            [18, 3, "#666666"],
            [18, 6, "#666666"],
            [18, 7, "#666666"],
            [18, 8, "#666666"],
            [18, 9, "#666666"],
            [18, 10, "#666666"],
            [18, 11, "#666666"],
            [18, 12, "#666666"],
            [18, 16, "#666666"],
            [18, 17, "#666666"],
            [18, 15, "#666666"],
            [3, 16, "#FFFF00"],
            [3, 17, "#FFFF00"],
            [4, 15, "#FFFF00"],
            [4, 16, "#FFFF00"],
            [4, 14, "#FFFF00"],
            [5, 14, "#FFFF00"],
            [5, 15, "#FFFF00"],
            [4, 17, "#FFFF00"],
            [5, 16, "#FFFF00"],
            [5, 13, "#FFFF00"],
            [6, 13, "#FFFF00"],
            [6, 14, "#FFFF00"],
            [17, 16, "#434343"],
            [17, 17, "#434343"],
            [17, 1, "#434343"],
            [16, 16, "#434343"],
            [16, 17, "#434343"],
            [16, 1, "#434343"],
            [16, 2, "#434343"],
            [15, 1, "#434343"],
            [15, 2, "#434343"],
            [15, 16, "#434343"],
            [15, 17, "#434343"],
            [14, 1, "#666666"],
            [14, 2, "#666666"],
            [14, 3, "#666666"],
            [14, 14, "#666666"],
            [14, 15, "#666666"],
            [14, 16, "#666666"],
            [14, 17, "#666666"],
            [12, 17, "#666666"],
            [12, 16, "#666666"],
            [12, 15, "#666666"],
            [12, 14, "#666666"],
            [12, 13, "#666666"],
            [12, 5, "#666666"],
            [12, 3, "#666666"],
            [12, 2, "#666666"],
            [12, 1, "#666666"],
            [12, 4, "#666666"],
            [10, 1, "#666666"],
            [8, 1, "#666666"],
            [8, 2, "#666666"],
            [8, 3, "#666666"],
            [8, 4, "#666666"],
            [8, 5, "#666666"],
            [8, 6, "#666666"],
            [8, 7, "#666666"],
            [8, 8, "#666666"],
            [8, 9, "#666666"],
            [8, 10, "#666666"],
            [8, 11, "#666666"],
            [8, 13, "#666666"],
            [8, 14, "#666666"],
            [8, 15, "#666666"],
            [8, 16, "#666666"],
            [8, 17, "#666666"],
            [8, 12, "#666666"],
            [10, 2, "#666666"],
            [10, 3, "#666666"],
            [10, 4, "#666666"],
            [10, 6, "#666666"],
            [10, 5, "#666666"],
            [10, 7, "#666666"],
            [10, 8, "#666666"],
            [10, 9, "#666666"],
            [10, 10, "#666666"],
            [10, 11, "#666666"],
            [10, 12, "#666666"],
            [10, 13, "#666666"],
            [10, 14, "#666666"],
            [10, 15, "#666666"],
            [10, 16, "#666666"],
            [10, 17, "#666666"],
            [6, 17, "#666666"],
            [6, 16, "#666666"],
            [6, 15, "#666666"],
            [6, 11, "#666666"],
            [6, 10, "#666666"],
            [6, 9, "#666666"],
            [6, 8, "#666666"],
            [6, 6, "#666666"],
            [6, 4, "#666666"],
            [6, 3, "#666666"],
            [6, 2, "#666666"],
            [6, 7, "#666666"],
            [6, 5, "#666666"],
            [6, 12, "#666666"],
            [4, 13, "#666666"],
            [4, 12, "#666666"],
            [4, 11, "#666666"],
            [4, 9, "#666666"],
            [4, 8, "#666666"],
            [4, 7, "#666666"],
            [4, 6, "#666666"],
            [4, 5, "#666666"],
            [4, 10, "#666666"],
            [5, 5, "#434343"],
            [5, 4, "#434343"],
            [5, 6, "#434343"],
            [5, 7, "#434343"],
            [5, 8, "#434343"],
            [5, 9, "#434343"],
            [5, 10, "#434343"],
            [5, 11, "#434343"],
            [5, 12, "#434343"],
            [5, 17, "#434343"],
            [7, 17, "#434343"],
            [7, 16, "#434343"],
            [7, 15, "#434343"],
            [7, 14, "#434343"],
            [7, 13, "#434343"],
            [7, 12, "#434343"],
            [7, 11, "#434343"],
            [7, 10, "#434343"],
            [7, 9, "#434343"],
            [7, 8, "#434343"],
            [7, 7, "#434343"],
            [7, 6, "#434343"],
            [7, 5, "#434343"],
            [7, 4, "#434343"],
            [7, 3, "#434343"],
            [7, 2, "#434343"],
            [7, 1, "#434343"],
            [9, 1, "#434343"],
            [9, 2, "#434343"],
            [9, 3, "#434343"],
            [9, 4, "#434343"],
            [9, 5, "#434343"],
            [9, 6, "#434343"],
            [9, 7, "#434343"],
            [9, 8, "#434343"],
            [9, 9, "#434343"],
            [9, 10, "#434343"],
            [9, 11, "#434343"],
            [9, 12, "#434343"],
            [9, 13, "#434343"],
            [9, 14, "#434343"],
            [9, 15, "#434343"],
            [9, 16, "#434343"],
            [9, 17, "#434343"],
            [11, 17, "#434343"],
            [11, 16, "#434343"],
            [11, 15, "#434343"],
            [11, 14, "#434343"],
            [11, 13, "#434343"],
            [11, 12, "#434343"],
            [11, 10, "#434343"],
            [11, 9, "#434343"],
            [11, 11, "#434343"],
            [11, 8, "#434343"],
            [11, 7, "#434343"],
            [11, 6, "#434343"],
            [11, 5, "#434343"],
            [11, 4, "#434343"],
            [11, 3, "#434343"],
            [11, 2, "#434343"],
            [11, 1, "#434343"],
            [13, 1, "#434343"],
            [13, 2, "#434343"],
            [13, 3, "#434343"],
            [13, 4, "#434343"],
            [13, 14, "#434343"],
            [13, 15, "#434343"],
            [13, 16, "#434343"],
            [13, 17, "#434343"],
            [14, 12, "#434343"],
        ],
    },
];
